module.exports = __webpack_public_path__ + "img/ann-reinking.34a3808f.jpg";